import React, { useEffect, useRef, useState } from 'react';
import './index.less';
import Block from '../Block';
import bricks1 from './bricks_1.png';
import bricks2 from './bricks_2.png';
import bricks3 from './bricks_3.png';
import bricks4 from './bricks_4.png';
import anime from 'animejs';
import { baseAnimeParams } from '../config';
import DOMPurify from 'dompurify';

export function PlatformValues() {
    useEffect(() => {
        anime({
            targets: ['#block-platform-value'],
            ...baseAnimeParams,
            opacity: [0, 1],
            translateY: [-40, 0],
        });
    }, []);

    return (
        <Block
            style={{
                opacity: 0,
            }}
            id="block-platform-value"
            title={
                <h2 id="platform-values">
                    <a href="#platform-values">平台价值 </a>
                </h2>
            }
            description="PLATFORM VALUES"
        >
            <div className="platform-values">
                <Card
                    title="数据资产沉淀"
                    desc="承接多方数据，构建广告主优质资产，夯实增长的基础。"
                    img={<img src={bricks1} />}
                    lineStroke={
                        <div className="lines1">
                            <i />
                            <i />
                        </div>
                    }
                    svgStr={path1}
                />
                <Card
                    title="精准触达目标人群"
                    desc="平台优质资源与多维营销矩阵，海量优质用户精准触达与转化机会。"
                    img={<img src={bricks2} />}
                    lineStroke={
                        <div className="lines2">
                            <i />
                            <i />
                        </div>
                    }
                    svgStr={path2}
                />
                <Card
                    title="业务增长引擎"
                    desc="人群价值分析，营销洞察分析，数据辅助商业决策，助力业务增长。"
                    img={<img src={bricks3} />}
                    lineStroke={
                        <div className="lines3">
                            <i />
                            <i />
                        </div>
                    }
                    svgStr={path3}
                />
                <Card
                    title="品牌影响力"
                    desc="形成资产-传播-流量的增长循环，扩大品牌受众，持续构建品牌影响力。"
                    img={<img src={bricks4} />}
                    lineStroke={
                        <div className="lines4">
                            <i />
                            <i />
                        </div>
                    }
                    svgStr={path4}
                />
            </div>
        </Block>
    );
}

export default React.memo(PlatformValues);

export function Card(props: {
    title: string;
    desc: string;
    img?: React.ReactChild;
    svgStr?: string;
    lineStroke?: React.ReactChild;
}) {
    const node = useRef<HTMLDivElement>(null);
    useEffect(() => {
        // if (node.current) {
        // }
    }, []);

    const [starPosition] = useState(() =>
        new Array(15).fill([0, 0]).map(() => {
            const x = Number(Math.random().toFixed(4)) * 600;
            const y = Number(Math.random().toFixed(4)) * 400;
            return [x, y];
        })
    );

    return (
        <div className="card-wrapper">
            <div ref={node} className="card">
                <div className="bg-circle" />
                {props.lineStroke}
                <div className="title">{props.title}</div>
                <div className="desc">{props.desc}</div>
                <div className="img">{props.img}</div>
                <div className="svg" dangerouslySetInnerHTML={{ __html: props.svgStr }} />
            </div>
        </div>
    );
}

const path1 = `
<svg width="638px" height="147px" viewBox="0 0 638 137" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="首页附属状态" transform="translate(-121.000000, -845.000000)" stroke="#1FCDDF" stroke-width="3">
            <g id="Group-Copy-10" transform="translate(100.000000, 649.000000)">
                <g id="Group-15" transform="translate(20.000000, 195.000000)">
                    <g id="Path_bricks_1" transform="translate(0.825414, 0.938965)">
                        <path d="M2,145.094238 L164.465601,145.094238 L164.465601,90.1452791 C164.465601,83.2909233 168.831616,77.1979789 175.322151,74.9945391 L241.615992,52.4887695 L241.615992,52.4887695 L241.615992,35.071281 C241.615992,28.2615213 245.92627,22.1979278 252.357789,19.959984 L301.593032,2.82783969 C304.995147,1.64402262 308.697198,1.64287239 312.100047,2.82457517 L362.085507,20.1829543 C368.521865,22.4180992 372.836695,28.4841041 372.836695,35.2975158 L372.836695,57.5844727 L372.836695,57.5844727 L439.140891,80.2994918 C445.609807,82.5156648 449.955347,88.597872 449.955347,95.4358765 L449.955347,115.094238 L449.955347,115.094238 L635.785806,115.094238"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`;

const path2 = `
<svg width="647px" height="125px" viewBox="0 0 638 167" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="首页附属状态" transform="translate(-880.000000, -849.000000)" stroke="#1FCDDF" stroke-width="3">
            <g id="Group-Copy-12" transform="translate(859.000000, 649.000000)">
                <g id="Path_bricks_2-2" transform="translate(19.904297, 201.356445)">
                    <path d="M1.70530257e-13,122.133789 L181.526367,122.133789 L192.96582,92.1171875 L192.96582,61.2157418 C192.96582,53.7749849 198.095221,47.3162839 205.342696,45.6313596 L251.286962,34.9500383 C255.134804,34.0554752 259.177559,34.6160408 262.636833,36.5238036 L301.993164,58.2285156 L301.993164,58.2285156 L326.328125,58.2285156 L326.328125,32.8819385 C326.328125,27.0657048 329.484372,21.7075663 334.571414,18.8878886 L363.362865,2.92917972 C366.768556,1.0414513 370.745763,0.460468048 374.549134,1.29510969 L420.532097,11.3859742 C427.872463,12.996802 433.102539,19.4990603 433.102539,27.0140941 L433.102539,91.6552734 L433.102539,91.6552734 L474.362033,107.283653 L643.591809,107.283653" id="Path_bricks_2"></path>
                </g>
            </g>
        </g>
    </g>
</svg>
`;

const path3 = `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="657px" height="147px" viewBox="0 0 657 127" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="首页附属状态" transform="translate(-1638.000000, -846.000000)" stroke="#1FCDDF" stroke-width="3">
            <g id="Group-Copy-13" transform="translate(1626.000000, 649.000000)">
                <g id="Path_bricks_3-2" transform="translate(14.054350, 197.878373)">
                    <path d="M0,144.121627 L106.724208,144.121627 L106.724208,103.56491 C106.724208,96.7286589 111.067555,90.647605 117.534151,88.430072 L189.97041,63.590143 L189.97041,63.590143 L189.97041,57.0059637 C189.97041,50.1496283 194.338907,44.0553859 200.832058,41.8534941 L319.208016,1.71103358 C322.48338,0.600325245 326.030466,0.580828366 329.317842,1.65546401 L452.524949,41.9315862 C459.103451,44.0820835 463.553476,50.2185469 463.553476,57.1396253 L463.553476,63.590143 L463.553476,63.590143 L535.212136,88.4090682 C541.654884,90.6405092 545.975729,96.7096969 545.975729,103.527932 L545.975729,120.121627 L545.975729,120.121627 L653.275791,120.121627" id="Path_bricks_3"></path>
                </g>
            </g>
        </g>
    </g>
</svg>
`;

const path4 = `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="656px" height="158px" viewBox="0 0 656 138" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="首页附属状态" transform="translate(-2444.000000, -837.000000)" stroke="#1FCDDF" stroke-width="3">
            <g id="Group-Copy-14" transform="translate(2428.000000, 649.000000)">
                <g id="Path_bricks_4" transform="translate(17.000000, 188.000000)">
                    <path d="M0.73828125,156 L165.939453,156 L165.939453,37.4882004 C165.939453,31.8503691 168.906611,26.6286345 173.749951,23.7429449 L207.151207,3.84228365 C210.81691,1.65823705 215.20315,1.02890061 219.33506,2.09414811 L373.892771,41.9406626 C380.959834,43.7626219 385.89842,50.1359087 385.89842,57.4340537 L385.89842,88.8070689 L385.89842,88.8070689 L419.547475,70.8367018 C425.426099,67.6972071 432.635103,68.5303669 437.642646,72.9279985 L477.315669,107.768911 C480.774808,110.806732 482.757812,115.187348 482.757812,119.791043 L482.757812,136 L482.757812,136 L652.976562,136"></path>
                </g>
            </g>
        </g>
    </g>
</svg>
`;
